import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { createProductImageUrl } from '../../utils/productImageUrl';
import { formatPurchaseDate } from '../../utils/formatPurchaseDate';
import { formatPrice } from '../../utils/formatPrice';
import { countTotalKey, productsKey, subtotalKey, tEc } from './ecText';

function lineTotal(product) {
  const unit = Number(product.product_price) - Number(product.product_discount || 0);
  const qty = Number(product.product_qty) || 0;
  return unit * qty;
}

function qtySum(lines) {
  return lines.reduce((sum, line) => sum + (Number(line.product_qty) || 0), 0);
}

function hideBrokenImage(event) {
  event.currentTarget.style.display = 'none';
}

function BackIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
      <path d="M15 5l-7 7 7 7" />
    </svg>
  );
}

function warrantyCopy(product, t) {
  const warranty = product.warranty_date;
  if (warranty == null || warranty === '') return null;
  if (warranty === 'OUT OF WARRANTY') return t('ordersLayout.ecWarrantyExpired');
  return t('ordersLayout.ecWarrantyActive');
}

export default function OfflineOrderDetailEc({ groupedOrder, onBack }) {
  const { t, i18n } = useTranslation();
  const lines = groupedOrder.product_list || [];
  const count = qtySum(lines);
  const currency = groupedOrder.product_price_currency || (lines[0] && lines[0].product_price_currency) || '';
  const storeName = groupedOrder.shop_name || groupedOrder.purchase_place || t('ordersLayout.storeAddressPending');
  const subtotal = lines.reduce((sum, line) => sum + lineTotal(line), 0);
  const amount = formatPrice(groupedOrder.order_grand_total, currency, i18n.language);

  useEffect(() => {
    const scroller = document.querySelector('.simplebar-content-wrapper');
    if (scroller) scroller.scrollTop = 0;
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="orders-ec">
      <header className="orders-ec__bar">
        <button type="button" className="orders-ec__back" aria-label={t('ordersLayout.ecBackToOrders')} onClick={onBack}>
          <BackIcon />
        </button>
        <h1 className="orders-ec__title">{groupedOrder.order_id}</h1>
        <span className="orders-ec__bar-end" aria-hidden="true" />
      </header>
      <main className="orders-ec__main">
        <p className="orders-ec-detail__lead">
          {tEc(t, 'ordersLayout.ecInStoreDate', {
            date: formatPurchaseDate(groupedOrder.purchase_date, i18n.language),
          })}
        </p>
        <div className="orders-ec-detail__store">
          <p className="orders-ec-detail__store-label">{t('ordersLayout.storeLabel')}</p>
          <p className="orders-ec-detail__store-name">{storeName}</p>
          {groupedOrder.thk_address ? (
            <p className="orders-ec-detail__address">{groupedOrder.thk_address}</p>
          ) : null}
        </div>
        <div className="orders-ec-detail__products">
          <div className="orders-ec-detail__products-head">
            <span>{t(productsKey(lines.length))}</span>
            <span>{tEc(t, countTotalKey(count), { count, amount })}</span>
          </div>
          {lines.map((product, index) => {
            const img = product.picture_url || createProductImageUrl(product);
            const name = product.product_name || t('ordersLayout.productNameFallback');
            const warranty = warrantyCopy(product, t);
            const lineCurrency = product.product_price_currency || currency;
            return (
              <div className="orders-ec-line" key={product.id || `${product.product_sku}-${index}`}>
                <div className="orders-ec-line__thumb">
                  {img ? <img src={img} alt="" onError={hideBrokenImage} /> : null}
                </div>
                <div className="orders-ec-line__body">
                  <p className="orders-ec-line__name">{name}</p>
                  <p className="orders-ec-line__meta">{tEc(t, 'ordersLayout.ecSku', { sku: product.product_sku || '' })}</p>
                  <p className="orders-ec-line__meta">{tEc(t, 'ordersLayout.ecQty', { qty: product.product_qty })}</p>
                  {warranty ? <p className="orders-ec-line__meta">{warranty}</p> : null}
                  <p className="orders-ec-line__price">
                    {formatPrice(lineTotal(product), lineCurrency, i18n.language)}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
        <div className="orders-ec-detail__totals">
          <div className="orders-ec-detail__subtotal">
            <span>{tEc(t, subtotalKey(count), { count })}</span>
            <span>{formatPrice(subtotal, currency, i18n.language)}</span>
          </div>
          <div className="orders-ec-detail__total">
            <span>{t('ordersLayout.totalLabel')}</span>
            <span>{amount}</span>
          </div>
        </div>
      </main>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/js/components/ordersLayout/OfflineOrderDetailEc.jsx